module.exports = __webpack_public_path__ + "img/MINUS.34263490.svg";